import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function Impenhorabilidade() {
  return (
    <section className="area-page">
      <h1>Impenhorabilidade de Terras e Implementos Rurais</h1>

      <p>Já ouviu falar sobre a "Lei do Bem de Família"?</p>

      <p>
        Tentar se defender com ela é um dos piores erros que um produtor rural
        pode cometer!
      </p>

      <p>
        Isso porque essa lei não tem aplicabilidade específica para as operações
        de crédito rural e possui muitos requisitos que, na maioria das vezes,
        os produtores rurais não conseguem cumprir. Por exemplo: você sabia que
        a Lei do Bem de Família prevê que se um bem foi dado em garantia da
        dívida ele não poderá ser considerado impenhorável? Só esse requisito já
        é suficiente para desenquadrar quase todas as operações de crédito rural
        (que habitualmente são garantidas por bens gravados com hipoteca ou
        alienação fiduciária).
      </p>

      <p>
        Felizmente existem outras ferramentas jurídicas, essas sim específicas
        para o crédito rural, que podem socorrer o produtor e conseguir a
        impenhorabilidade de seus bens mesmo quando eles foram dados em garantia
        da dívida (tanto na forma de hipoteca, quanto na forma de alienação
        fiduciária).
      </p>

      <p>
        Se você precisa de ajuda para reconhecer a impenhorabilidade dos seus
        bens, ou mais informações sobre esse tema, clique no botão abaixo para
        falar gratuitamente com nossos especialistas, direto no seu WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default Impenhorabilidade;
